import React from 'react'

const Icon: React.FC<any> = ({ ...props }) => {
  return (
    <svg {...props} viewBox="0 0 28 28">
      <path d="M2.33337 26.8333L26.8334 2.33331 M26.8334 26.8333L2.33337 2.33331" />
    </svg>
  )
}

export default Icon
